import css from '@styled-system/css';
import axios from 'axios';
import {arrayOf, number, shape, string} from 'prop-types';
import {useEffect} from 'react';
import Card from '../../shared/Card';
import Box from '../../shared/layouts/Box';
import Stack from '../../shared/layouts/Stack';
import {formatISODate} from '../../../utils/dateHelpers';
import styled from '@emotion/styled';
import DisplayLine from "../../shared/DisplayLine";
import FileAttachmentButton from "../../shared/FileAttachmentButton";
import {useTranslation} from "react-i18next";

const MessageBox = styled(Box)(({ theme }) => ({
  wordBreak: 'break-word',
  a: {
    color: theme.colors.primary,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.colors.primaryActive
    }
  }
}));

const MessageDetail = ({
  attachments,
  created_at,
  message,
  subject,
  read_at,
  organization_message_uuid,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (organization_message_uuid && !read_at) axios.patch(`/messages/${organization_message_uuid}`);
  }, [organization_message_uuid, read_at]);

  return (
    <Card>
      <Stack space="xl">
        <Box borderBottom="default" pb="m">
          <Stack space="l">
            <Box fontScale="l" fontWeight="bold">
              {subject}
            </Box>
            <Stack space="l" maxWidth="37.5rem">
              <DisplayLine label={t("Ontvangen op")} value={formatISODate(created_at)} />
            </Stack>
          </Stack>
        </Box>
        <Stack space="l">
          <MessageBox dangerouslySetInnerHTML={{ __html: message }} />
          <Box
            px="s"
            css={css({ marginLeft: '-16px', '> *': { margin: 's' } })}
          >
            {attachments.map(({ file_name, download_url, is_deleted }) => (
              <FileAttachmentButton
                key={file_name}
                fileName={file_name}
                fileUrl={download_url}
                isDeleted={is_deleted}
              />
            ))}
          </Box>
        </Stack>
      </Stack>
    </Card>
  );
};

MessageDetail.propTypes = {
  attachments: arrayOf(
    shape({
      download_url: string,
      file_name: string,
      file_size: number,
      organization_files_id: number,
      organization_message_uuid: string,
    })
  ),
  created_at: string,
  message: string,
  subject: string,
  receiver: string,
};

MessageDetail.defaultProps = {
  attachments: [],
  created_at: '',
  message: '',
  subject: '',
  receiver: '',
};

export default MessageDetail;
